import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "50%",
  height: "50%",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.00119 9.41443L13.5997 15.0129L15.0139 13.5987L9.4154 8.00021L15.0141 2.40152L13.5999 0.987305L8.00119 6.586L2.40249 0.987305L0.988281 2.40152L6.58698 8.00021L0.988485 13.5987L2.4027 15.0129L8.00119 9.41443Z" }, null, -1)
  ]))]))
}
export default { render: render }